import React, { FC, memo } from 'react'

import { BottomSheet } from '@interco/inter-ui/components/BottomSheet'

import { DisableAllNotificationsBottomsheetConfirmation } from './disable-all-notifications-bottomsheet-confirmation/DisableAllNotificationsBottomsheetConfirmation'
import { DisableAllNotificationsBottomsheetSuccess } from './disable-all-notifications-bottomsheet-success/DisableAllNotificationsBottomsheetSuccess'
import { TDisableAllNotificationsBottomsheetProps } from '../types/DisableAllNotificationsBottomsheet.types'
import { useDisableAllNotifications } from '../hooks/useDisableAllNotifications'

export const DisableAllNotificationsBottomsheet: FC<TDisableAllNotificationsBottomsheetProps> =
  memo(({ producId }) => {
    const {
      showDialogBR,
      showDialogUS,
      showSuccessStepBR,
      showSuccessStepUS,
      mutationBR,
      mutationUS,
      onConfirm,
      onDismiss,
      onClose,
    } = useDisableAllNotifications({ producId })
    if (!showDialogBR && !showDialogUS) return null

    return (
      <BottomSheet onClose={onClose}>
        {showSuccessStepBR === false && showSuccessStepUS === false && (
          <DisableAllNotificationsBottomsheetConfirmation
            isLoading={mutationUS?.isPending || mutationBR?.isPending}
            onConfirm={onConfirm}
            onDismiss={onDismiss}
          />
        )}
        {(showSuccessStepBR || showSuccessStepUS) && (
          <DisableAllNotificationsBottomsheetSuccess onDismiss={onDismiss} />
        )}
      </BottomSheet>
    )
  })
